import React from 'react'
import './nav.css';
function Nav() {
  
  return (
    <div className='nav'>
      <img className='nav_logo'
   
   src="https://th.bing.com/th/id/R.e0fb2f11338b8b9bc8595f44a09f4091?rik=f%2fgufNZj%2foyMIg&riu=http%3a%2f%2fnativeadvertisinginstitute.com%2fwp-content%2fuploads%2f2015%2f03%2fNetflix_Logo_Digital-Video.png&ehk=qwvBugudvcTWKnUHtXeS%2fE9o8mq%2bwYSz%2fXY8EORlmTQ%3d&risl=&pid=ImgRaw&r=0" alt='Netflix Logo'/>
   <img className='avatar_logo'
   src="https://mir-s3-cdn-cf.behance.net/project_modules/disp/366be133850498.56ba69ac36858.png" alt='avatar Logo'/>
    </div>
  )
}

export default Nav;
